// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { z } from 'zod';
export const dspScreeningId = (z.number());
export const dspScreening = z.object({
    id: dspScreeningId,
    created_at: z.date(),
    fermentation_id: fermentationId.nullable(),
});
export const dspScreeningInitializer = z.object({
    id: dspScreeningId.optional(),
    created_at: z.date().optional(),
    fermentation_id: fermentationId.optional().nullable(),
});
export const dspScreeningMutator = z.object({
    id: dspScreeningId.optional(),
    created_at: z.date().optional(),
    fermentation_id: fermentationId.optional().nullable(),
});
//# sourceMappingURL=DspScreening.js.map